import { isActiveTeamMember } from "../utils/teamAccess";

export function buildDealOwnerAssignment(memberId, members, actorUid, now = new Date()) {
  const member = members.find((item) => item.id === memberId);
  if (memberId && (!member || !isActiveTeamMember(member))) {
    throw new Error("Choose an active member of this workspace.");
  }
  return {
    assignedToUserId: memberId || "",
    ownerUid: memberId ? member.uid || member.id : "",
    ownerName: member?.name || "",
    assignedToNameSnapshot: member?.name || "",
    assignedTo: member?.name || "",
    assignedAt: memberId ? now : null,
    assignedBy: memberId ? actorUid : "",
  };
}
